import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from '../button/button.component';

export type ConfirmDialogType = 'normal' | 'warning' | 'error';

export interface ConfirmDialogData {
  type?: ConfirmDialogType;
  title?: string;
  description?: string;
  confirmTextKey?: string;
  cancelTextKey?: string;
}

@Component({
  selector: 'ctr-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, ButtonComponent, TranslateModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  readonly type: ConfirmDialogType;
  readonly title: string;
  readonly description?: string;
  readonly confirmTextKey: string;
  readonly cancelTextKey: string;
  private dialogRef = inject(MatDialogRef<ConfirmDialogComponent, boolean>);
  private data = inject(MAT_DIALOG_DATA);

  constructor() {
    this.type = this.data?.type ?? 'normal';
    this.title = this.data?.title ?? 'ui.confirmDialog.defaultTitle';
    this.description = this.data?.description ?? 'ui.confirmDialog.defaultDescription';
    this.confirmTextKey = this.data?.confirmTextKey ?? 'ui.confirmDialog.confirm';
    this.cancelTextKey = this.data?.cancelTextKey ?? 'ui.confirmDialog.cancel';
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  get headerIcon(): string {
    switch (this.type) {
      case 'warning':
        return 'warning_amber';
      case 'error':
        return 'error';
      default:
        return 'info';
    }
  }

  get headerClasses(): string {
    switch (this.type) {
      case 'warning':
        return 'bg-amber-50 text-amber-600';
      case 'error':
        return 'bg-red-50 text-red-600';
      default:
        return 'bg-neutral-50 text-neutral-600';
    }
  }
}
